import { styled } from "@mui/material"
import { palette } from "view/themes/palette"

export const Wrapp = styled("div")(() => ({
  padding: "0 32px",
}))

export const LoadingWrapp = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "calc(100vh - 250px)",
}))

export const EmptyScreenWrapp = styled("div")(() => ({
  height: "calc(100vh - 186px)",
}))

export const Info = styled("div")(() => ({
  marginBottom: 24,
}))

export const NameWrapp = styled("div")(() => ({
  marginBottom: 16,
  display: "flex",
  alignItems: "center",
}))

export const NameLabel = styled("div")(() => ({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: "20px",
  paddingRight: 8,
}))

export const NameInp = styled("div")(() => ({
  pointerEvents: "none",
}))

export const NameCopy = styled("div")(() => ({
  marginLeft: 16,
}))

export const SettingsTopWrapp = styled("div")(() => ({
  position: "relative",
}))

export const SettingsTop = styled("div")(() => ({
  fontWeight: 600,
  lineHeight: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
  padding: "16px 32px",
  backgroundColor: palette.white,
  position: "relative",
  zIndex: 10,
}))

export const SettingsTopShadow = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  zIndex: 5,
  width: "100%",
  height: 8,
  boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.08)",
}))

export const SettingsTopBtns = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
}))

export const TabsLabel = styled("div")(() => ({
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
}))

export const TabContent = styled("div")(() => ({
  marginTop: 24,
}))

export const TabsThemeOverride = {
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 32,

          "& .MuiButtonBase-root": {
            padding: "0 8px",
          },

          "& .MuiTabs-flexContainer": {
            gap: 8,
          },
        },
        scroller: {
          minHeight: 32,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {},
        root: {
          minHeight: 32,
          "& .MuiButtonBase-root": {
            minHeight: 32,
          },
        },
      },
    },
  },
}
